import { graphql } from 'gql.tada';
import { client } from '../client';

export const createPresignedUrlMutation = graphql(`
  mutation CreatePresignedUrl($input: CreatePresignedUrlInput!) {
    createPresignedUrl(input: $input) {
      id
      url
      headers
      fields
    }
  }
`);

export const createPresignedUrlMutationFn = (
  variables: CreatePresignedUrlVariables,
) => client.request(createPresignedUrlMutation, variables);

/* eslint-disable typescript/no-explicit-any -- Required for gql.tada type inference */
export type CreatePresignedUrlVariables =
  typeof createPresignedUrlMutation extends import('gql.tada').TadaDocumentNode<
    any,
    infer T,
    any
  >
    ? T
    : never;
/* eslint-enable typescript/no-explicit-any */
